<template>
    <div class="artist-container">
        <div class="title-box">
            <p>华艺元界，为艺术家赋能</p>
            <p>
                <countTo :startVal="0" :endVal="13450" :duration="3000"></countTo>位艺术家已加入
            </p>
        </div>
        <div class="jonin-btn">
            <button @click="joinCreator">入驻成为创作者</button>
        </div>
        <div class="from">
            <img src="" alt="">
        </div>
        <div class="avatar-container">
            <div class="row1">
                <div class="avatar-row">
                    <div class="avatar-item"
                    @mouseover="setIsShow(i)"
                    @mouseleave="setIsHidden"
                    v-for="(item, i) in rowAvatar_1.concat(rowAvatar_1.concat(rowAvatar_1))" :key="i">
                        <img :src="item.imageUrl" alt="">
                        <span>{{ item.name }}</span>
                        <div class="desc-box" v-show="index===i"  >
                            <p>粉丝数:{{ item.fansCount }}</p>
                            <p>作品:{{ item.artArtuclesCount }}</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row2">
                <div class="avatar-row">
                    <div class="avatar-item"
                    @mouseover="setIsShow2(i)"
                     @mouseleave="setIsHidden"
                    v-for="(item, i) in rowAvatar_2.concat(rowAvatar_2.concat(rowAvatar_2))" :key="i">
                        <img :src="item.imageUrl" alt="">
                        <span>{{ item.name }}</span>
                        <div class="desc-box" v-show="index2===i"  >
                            <p>粉丝:{{ item.fansCount }}</p>
                            <p>作品:&nbsp;{{ item.artArtuclesCount }}</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import countTo from 'vue-count-to'
import { getUser } from '@/api/getUserinfo'

export default {
    components: {
        countTo
    },
    data () {
        return {
            rowAvatar_1: [],
            rowAvatar_2: [],
            isShow: false,
            index: 99,
            index2: 88,
            artistNumber: 14355
        }
    },
    async created () {
        const res = await getUser()
        this.rowAvatar_1 = res.slice(0, 10)
        console.log(res.length)
        this.rowAvatar_2 = res.slice(10, 20)
    },
    methods: {
        setIsShow (i) {
            this.index = i
            console.log('xx', this.index)
        },
        setIsShow2 (i) {
            this.index2 = i
            console.log('xx', this.index)
        },
        setIsHidden () {
            this.index = 99
            this.index2 = 99
        },
        joinCreator() {
            window.open('https://wj.qq.com/s2/22590019/920a/?wj_lang=zhs', '_blank');
        }
    }
}
</script>

<style lang="less" scoped>
@keyframes slide {
    to {
        transform: translateX(calc(-50% + 8.1rem));
    }
}

.artist-container {
    width: 100%;
    height: auto;
    padding-top: 80px;

    .title-box {
        width: 100%;
        color: #1F2329;

        &>p:nth-child(1) {
            text-align: center;
            font-size: 16px;
            margin-bottom: 10px;
            letter-spacing: .5rem;
        }

        &>p:nth-child(2) {
            font-size: 36px;
            font-weight: 500;

        }
    }

    .jonin-btn {
        width: 100%;
        padding-top: 20px;

        button {
            width: 284px;
            height: 40px;
            display: inline-block;
            align-items: center;
            justify-content: center;
            background-color: #FF7A3B;
            color: rgb(255, 255, 255);
            border: none;
            border-radius: 8px;
            font-size: 14px;
            font-weight: 500;
            cursor: pointer;
            box-sizing: border-box;

            &:hover {
                background-color: #de6f3c;
            }
        }
    }

    .avatar-container {
        position: relative;
        display: flex;
        flex-wrap: wrap;
        width: 100%;
        height: auto;
        padding-top: 40px;
        mask: linear-gradient(90deg,transparent,#fff 5%,#fff 95%,transparent);
        overflow: hidden;
        .avatar-row {
            position: absolute;
            display: flex;
            gap: 1rem;
            flex-shrink: 0;
            width: max-content;
            height: 120px;
            animation: slide 35s linear infinite;

            /* 调整动画时长和效果 */
            .avatar-item {
                position: relative;
                width: 120px;
                height: 120px;
                box-sizing: content-box;
                border-radius: 10px;

                img {
                    width: 120px;
                    height: 120px;
                    border-radius: 10px;
                }

                span {
                    line-height: 20px;
                }

                &:hover {
                    cursor:text;
                }
                .desc-box {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 120px;
                    height: 120px;
                    background-color: rgba(#FF7A3B, 0.8);
                    border-radius: 10px;
                    color: #fff;
                    transition: all .5s;
                    p {
                        display: inline-block;
                        width: 100%;
                        font-size: 14px;
                        text-align: center;
                        margin-top: 10px;
                        margin-left: 10px;
                    }
                }
            }

        }
        .row2 {
            // width: 100%;
            height: 220px;
            margin-top: 200px;
        }
    }
}
</style>